import React from "react";

const Building23A = () => {
  // Additional images for Variant Apartment Building
  const additionalImages = [
    "/images/Picture54.jpg",
    "/images/Picture55.jpg",
    "/images/Picture56.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Variant Apartment Building at Plot No. 23/24, Gulberg III</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Below is a list of the project details for the Variant Apartment Building, where <strong>PACIFIC BUILDERS (PVT) LTD</strong> has executed high-standard construction work with an emphasis on precision and quality.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Structural works</p>
            <p><strong>Architect:</strong> Variant Architects</p>
            <p><strong>Project Description:</strong> Variant Apartment Building located at Plot No. 23/24, Gulberg III, is a modern residential complex.</p>
            <p><strong>Location:</strong> Plot No. 23/24, Gulberg III, Lahore</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture53.jpg"
            alt="Variant Apartment Building Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Variant Apartment Building ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Building23A;
